import { Pipe, PipeTransform } from '@angular/core';
import { TravelCategory } from '../../api/models';

@Pipe({
  name: 'travelType'
})
export class TravelTypePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    let src: Map<number, string> = new Map([
      [1, "/assets/imgs/worldwide.png"],
      [2, "/assets/imgs/pray.png"],
      [3, "/assets/imgs/shoes.png"],
      [4, "/assets/imgs/nature.png"],
      [5, "/assets/imgs/diamond.png"],
      [6, "/assets/imgs/sea.png"],
    ])
    return (src.get(value)) || "/assets/imgs/worldwide.png";
  }

}